import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "mb-3 font-size-14-600" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "pl-3" }
const _hoisted_5 = { class: "round-primary-button primary-background-button-color" }
const _hoisted_6 = { class: "font-20" }
const _hoisted_7 = { class: "font-14" }
const _hoisted_8 = { class: "font-14" }

import CardComponent from "@/components/custom/CardComponent.vue";
import Icon from "@/components/Icons/Icon.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'EventsAndActivityPanelCard',
  props: {
  icon: {
    type: String,
    default: 'calendar-icon-thin'
  },
  title: {
    type: String,
    default: 'Events'
  },
  subTitle: {
    type: String,
    default: 'Upcoming Event'
  },
  firstRow: {
    type: String,
    default: 'You have no booked'
  },
  secondRow: {
    type: String,
    default: 'events'
  },
  emptyContentCustomClass: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardComponent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(Icon, {
                icon: __props.icon,
                color: "white"
              }, null, 8, ["icon"])
            ])
          ]),
          _renderSlot(_ctx.$slots, "customContent", {}, () => [
            _createElementVNode("div", {
              class: _normalizeClass([__props.emptyContentCustomClass, "ml-3 py-2"])
            }, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.subTitle), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.firstRow), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(__props.secondRow), 1)
            ], 2)
          ])
        ])
      ])
    ]),
    _: 3
  }))
}
}

})